// JavaScript Document
// 所有服务层调用接口
// 作者 lwch
// 投产前注意去除调试Alert
/* eslint-disable */

(function ($) {
	function serarchTopWindow(win) {
		if (!!win._TOP_WINDOW) {
			return win;
		} else if (win.parent !== win) {
			serarchTopWindow(win.parent)
		} else {
			return win;
		}
	}

	var DAY_SERIALNO_START = 0;
	var ASYN_0 = '0';
	var ASYN_1 = '1';
	var FIRST_SPLIT = '#$#';
	var SECOND_SPLIT = '#=#';

	function GetSerialNo() {
		return DAY_SERIALNO_START++;
	}

	function ParseMsg(rec_data, split_str, i) { //获取第i个返回参数 i从0下标开始
		var i_str = '';
		if (rec_data == '' || i < 0) {
			return i_str;
		}
		try {
			var arr = rec_data.split(split_str);
			if (arr.length < i + 1) {
				return i_str;
			} else {
				return arr[i];
			}
		} catch (e) {
			alert(e);
		}
		return i_str;
	}

	$.busitrans = {
		/**
		 * 外屏
		 * 开始读身份证
		 * @param {function} successfun 读卡成功回调方法
		 * @param {function} failedfun 读卡失败回调方法
		 */
		readIDCard: function (successfun, failedfun) {
			var externalback = "TransGet" + (Math.random() + "").substr(5);;
			top.window[externalback] = function (rec) {

				var rcode = ParseMsg(rec, FIRST_SPLIT, 2);
				var rmsg = ParseMsg(rec, FIRST_SPLIT, 3);
				if (rcode != null && rcode == '0') {
					if (successfun != null && $.isFunction(successfun)) {
						successfun(rmsg);
					}
				} else if (rcode != null && rcode == '6') {
					//设备正在使用中
					if (failedfun != null && $.isFunction(failedfun)) {
						failedfun(rcode + "," + rmsg);
					}
				} else if (rcode != null && rcode == '1') {
					//设备正在使用中
					if (failedfun != null && $.isFunction(failedfun)) {
						failedfun(rcode + "," + rmsg);
					}
				} else {
					if (failedfun != null && $.isFunction(failedfun)) {
						failedfun(rcode + "," + rmsg);
					}
				}
				try {
					delete top.window[externalback];
				} catch (e) {
				}
			};

			var TransCode = "GI0001";
			var SerialNo = GetSerialNo();
			var SetValue = "";
			var Asyn = ASYN_0;
			var sendmsg = TransCode + FIRST_SPLIT + SerialNo + FIRST_SPLIT + SetValue + FIRST_SPLIT + Asyn;
			top.window.external.tRANSTO(sendmsg, externalback);
			return;
		},
		/**
		 * 外屏
		 * 停止读身份证
		 */
		stopIDCard: function () {
			var TransCode = "GI0003";
			var SerialNo = GetSerialNo();
			var SetValue = "";
			var Asyn = ASYN_1;
			var sendmsg = TransCode + FIRST_SPLIT + SerialNo + FIRST_SPLIT + SetValue + FIRST_SPLIT + Asyn;
			var rec = top.window.external.tRANSTO2(sendmsg);
			var rcode = ParseMsg(rec, FIRST_SPLIT, 2);
			if (rcode == '0') {
				return '';
			}
			var recmsg = ParseMsg(rec, FIRST_SPLIT, 3);
			return rcode + "," + recmsg;
		},
		/**
		 * 外屏
		 * 开始读银行卡
		 * @param {function} successfun 读卡成功回调方法
		 * @param {function} failedfun 读卡失败回调方法
		 */
		readCard: function (successfun, failedfun) {
			var externalback = "TransGet" + (Math.random() + "").substr(5);;
			top.window[externalback] = function (rec) {
				var rcode = ParseMsg(rec, FIRST_SPLIT, 2);
				var rmsg = ParseMsg(rec, FIRST_SPLIT, 3);
				if (rcode != null && rcode == '0') {
					if (successfun != null && $.isFunction(successfun)) {
						successfun(rmsg);
					}
				} else if (rcode != null && (rcode == '6' || rcode == '1')) {
					//6.设备正在使用中  1.界面取消按键
				} else {
					if (failedfun != null && $.isFunction(failedfun)) {
						failedfun(rcode + "," + rmsg);
					}
				}
				try {
					delete top.window[externalback];
				} catch (e) {
				}
			};

			var TransCode = "GC0001";
			var SerialNo = GetSerialNo();
			var SetValue = 0;
			var Asyn = ASYN_0;
			var sendmsg = TransCode + FIRST_SPLIT + SerialNo + FIRST_SPLIT + SetValue + FIRST_SPLIT + Asyn;
			top.window.external.tRANSTO(sendmsg, externalback);
			try {
				return top.window.external.playAudio("1.wav");
			} catch (e) {
			}
		},
		/**
		 * 外屏
		 * 停止读银行卡
		 */
		stopCard: function () {
			var TransCode = "SC0003";
			var SerialNo = GetSerialNo();
			var SetValue = 0;
			var Asyn = ASYN_1;
			var sendmsg = TransCode + FIRST_SPLIT + SerialNo + FIRST_SPLIT + SetValue + FIRST_SPLIT + Asyn;
			var rec = top.window.external.tRANSTO2(sendmsg);
			try {
				return top.window.external.stopAudio();
			} catch (e) {
			}
			var rcode = ParseMsg(rec, FIRST_SPLIT, 2);
			if (rcode == '0') {
				return '';
			}
			var recmsg = ParseMsg(rec, FIRST_SPLIT, 3);
			return rcode + "," + recmsg;
		},
		/**
		 * 外屏
		 * 获取银行卡状态：是否插入卡片
		 * @param {function} successfun 成功回调方法
		 * @param {function} failedfun 失败回调方法
		 */
		getCardState: function (successfun, failedfun) {
			var externalback = "TransGet" + (Math.random() + "").substr(5);;
			top.window[externalback] = function (rec) {
				var rcode = ParseMsg(rec, FIRST_SPLIT, 2);
				var rmsg = ParseMsg(rec, FIRST_SPLIT, 3);

				if (rcode != null && rcode == '0') {
					if (successfun != null && $.isFunction(successfun)) {
						successfun(rmsg);
					}
				} else if (rcode != null && (rcode == '6' || rcode == '1')) {
					//6.设备正在使用中  1.界面取消按键
				} else {
					if (failedfun != null && $.isFunction(failedfun)) {
						failedfun(rcode + "," + rmsg);
					}
				}
				try {
					delete top.window[externalback];
				} catch (e) {
				}
			};

			var TransCode = "GC0004";
			var SerialNo = GetSerialNo();
			var SetValue = "";
			var Asyn = ASYN_0;
			var sendmsg = TransCode + FIRST_SPLIT + SerialNo + FIRST_SPLIT + SetValue + FIRST_SPLIT + Asyn;
			top.window.external.tRANSTO(sendmsg, externalback);
		},
		/**
		 * 外屏
		 * 启用密码键盘(客户端UI),并返回密文
		 * @param {string} title 标题
		 * @param {string} cardNo 卡号信息，一般显示后四位
		 * @param {string} project 项目：qhd-秦皇岛；heb-哈尔滨；默认为空
		 */
		getPwdByCardNo: function (title, cardNo, project) {
			top.window.external.playAudio("2.wav");
			return top.window.external.getPwdByCardNo(title, cardNo, project);
		},
		/**
		 * 外屏
		 * 启用密码键盘(客户端UI),并返回密文
		 * @param {string} title 标题
		 * @param {number} num 金额
		 * @param {string} cardNo 卡号信息，一般显示后四位
		 * @param {string} project 项目：qhd-秦皇岛；heb-哈尔滨；默认为空
		 */
		getPwdByCardAndMoney: function (title, num, cardNo, project) {
			top.window.external.playAudio("2.wav");
			return top.window.external.getPwdByCardAndMoney(title, num, cardNo, project);
		},
		/**
		 * 外屏
		 * 启动密码键盘(网页UI)
		 * @param {function} func 密码键盘回调函数
		 * @param {number} type 密码键盘加密类型：2-3DS；7-SM4。默认2
		 * 0：数字；-1：更正；-2：确认；-3：取消
		 * 60秒超时，输满六位生成密文，按更正需全清
		 */
		startReadPinKey: function (func, type) {
			try {
				var externalback = "readPinKeyCallback";
				top.window[externalback] = function (rcode) {
					if (func != null && $.isFunction(func)) {
						func(rcode);
					}
				};
				top.window.external.playAudio("2.wav");
				top.window.external.startReadPinKey(externalback, type);
			} catch (e) {
			}
		},
		/**
		 * 外屏
		 * 关闭密码键盘(网页UI),并返回密文
		 */
		endReadPinKey: function () {
			try {
				return top.window.external.endReadPinKey();
			}
			catch (e) {
				return '-9999';
			}
		},
		/**
		 * 外屏
		 * 设置密码键盘密钥信息,外屏刷完卡之后调此方法写入PinCodeConfig.xml
		 * code-初始密钥
		 * mainCodeH-主密钥
		 * workCodeH-工作密钥
		 * mainCheck-主密钥校验值
		 * workCheck-工作密钥校验值
		 * zero-标志位
		 * count-银行卡号
		 * @param {string} type xml节点，key值参考上方
		 * @param {string} content xml节点值
		 */
		setCodeXml: function (type, content) {
			try {
				return top.window.external.setCodeXml(type, content);
			}
			catch (e) {
				return '-9999';
			}
		},
		/**
		 * 外屏
		 * 启动双录
		 * @param {string} ip 摄像头ip地址，默认169.254.0.1
		 * @param {number} port 摄像头端口号，默认9101
		 * @param {string} file 录像文件名
		 * @param {number} timeout 超时(毫秒)，默认30000
		 * 返回0表示正常，其他异常
		 */
		startBatchRecord: function (file) {
			try {
				return top.window.external.startBatchRecord('169.254.0.1', '9101', file, 30000);
			} catch (e) {
				return '-9999';
			}
		},//outside
		/**
		 * 外屏
		 * 关闭双录
		 * 返回0表示正常，其他异常
		 * @param {number} type 关闭类型：1-停止录像；2-取消录像
		 */
		endBatchRecord: function (type) {
			try {
				return top.window.external.endBatchRecord(type);
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 外屏
		 * 设置双录状态，仅在双录开启时有效
		 * @param {string} status 状态；hide-隐藏；show-显示
		 * 返回0表示正常，其他异常
		 */
		netCamStatus: function (status) {
			try {
				return top.window.external.netCamStatus(status);
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 外屏
		 * 获取双录状态
		 * open#=#show 双录开启，显示状态
		 * open#=#hide 双录开启，隐藏状态
		 * close#=#hide 双录关闭状态
		 */
		getCamStatus: function () {
			try {
				return top.window.external.getCamStatus();
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 内屏/外屏
		 * 更新上传配置文件VideoUploadConfig.xml
		 * @param {string} uploadParam 文件内容
		 */
		writeVideoUploadFile: function (uploadParam) {
			try {
				return top.window.external.writeVideoUploadFile(uploadParam);
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 外屏
		 * 写入屏保数据
		 * @param {number} timeout 屏保显示时间(分钟)
		 * @param {number} sumCount 图片数量
		 * @param {string} fileUrls 图片url，多张图片用英文逗号分割
		 */
		writeScreenSaver: function (timeout, sumCount, fileUrls) {
			try {
				return top.window.external.writeScreenSaver(timeout, sumCount, fileUrls);
			} catch{
				return '-9999';
			}
		},
		/**
		 * 内屏/外屏
		 * 打印Html文档
		 * @param {string} content 打印内容
		 * @param {number} count 打印数量
		 * @param {number} f 0-纵向;1-横向
		 */
		webPrint: function (content, count, f) {
			try {
				return top.window.external.webPrint(content, count, f);
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 内屏
		 * 打印当前网页
		 */
		print: function () {
			try {
				top.window.external.print();
				return 0;
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 外屏
		 * 语音播报
		 * @param {string} text 播放文本
		 * @param {number} rate 播放速率-10~10，默认0
		 * @param {number} volume 音量大小1~100，默认100
		 * @param {number} gender 声音类型：1-男声；0-女生
		 * @param {function} func 播放完成，回调函数
		 */
		startVoiceCallback: function (text, func) {
			try {
				return top.window.external.startVoiceCallback(text, 0, 100, 0, func);
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 外屏
		 * 语音播报
		 * @param {string} text 播放文本
		 * @param {number} rate 播放速率-10~10，默认0
		 * @param {number} volume 音量大小1~100，默认100
		 * @param {number} gender 声音类型：1-男声；0-女生
		 */
		startVoice: function (text) {
			try {
				return top.window.external.startVoice(text, 0, 100, 0);
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 外屏
		 * 停止播报
		 */
		stopVoice: function () {
			try {
				return top.window.external.stopVoice();
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 外屏
		 * 暂停播报
		 */
		pauseVoice: function () {
			try {
				return top.window.external.pauseVoice();
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 外屏
		 * 继续播报
		 */
		resumeVoice: function () {
			try {
				return top.window.external.resumeVoice();
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 外屏
		 * 播放音频
		 * @param {string} file 文件名称，默认路径为客户端audio目录下
		 * 返回0-正常
		 * 其他-异常
		 */
		playAudio: function (file) {
			try {
				return top.window.external.playAudio(file);
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 外屏
		 * 停止播放
		 * 返回0-正常
		 * 其他-异常
		 */
		stopAudio: function () {
			try {
				return top.window.external.stopAudio();
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 内屏/外屏
		 * 新建或跳转浏览器(多Tab，隐藏标签)
		 * @param {string} key 浏览器标签，为空时返回正在显示的标签，财富E站通为default
		 * @param {string} url 浏览器地址，为空时不进行加载网页操作
		 * 返回0-新建标签成功
		 * 返回1-跳转标签成功，未加载网页
		 * 返回2-跳转标签成功，并加载网页
		 * 其他-异常
		 */
		loadChrome: function (key, url) {
			try {
				return top.window.external.loadChrome(key, url);
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 内屏/外屏
		 * 发送通信键值对
		 * @param {string} key 键,一般为jscall,内屏登录/登出时发送islogin,managerno
		 * @param {string} val 值
		 */
		sendKeyValue: function (key, value) {
			try {
				return top.window.external.sendKeyValue(key, value);
			}
			catch (e) {
				return '-9999';
			}
		},
		/**
		 * 内屏/外屏
		 * 设置本地键值对
		 * @param {string} key 键,内屏登录/登出时写入workno,bank,外屏进入/离开首页时写入ishome
		 * @param {string} val 值
		 */
		setParamValue: function (key, value) {
			try {
				return top.window.external.setParamValue(key, value);
			}
			catch (e) {
				return '-9999';
			}
		},
		/**
		 * 内屏/外屏
		 * 获取本地字典值
		 * @param {string} key 键,外屏开始使用时取islogin判断是否理财经理登录
		 */
		getParamValue: function (key) {
			try {
				return top.window.external.getParamValue(key);
			}
			catch (e) {
				return '-9999';
			}
		},
		/**
		 * 内屏/外屏
		 * 获取键值对
		 * 旧版本方法，暂时保留，不建议使用
		 * @param {string} key 键
		 */
		getOldParamValue: function (key) {
			var TransCode = "GH0001";
			var SerialNo = GetSerialNo();
			var SetValue = key;
			var Asyn = ASYN_1;
			var sendmsg = TransCode + FIRST_SPLIT + SerialNo + FIRST_SPLIT + SetValue + FIRST_SPLIT + Asyn;
			var rec = top.window.external.tRANSTO2(sendmsg);
			var rcode = ParseMsg(rec, FIRST_SPLIT, 2);
			if (rcode != '0') {
				return '';
			}
			var recmsg = ParseMsg(rec, FIRST_SPLIT, 3);
			recmsg = ParseMsg(recmsg, SECOND_SPLIT, 1);
			return recmsg;
		},
		/**
		 * 内屏/外屏
		 * 设置键值对
		 * 旧版本方法，暂时保留，不建议使用
		 * @param {string} key 键
		 * @param {string} val 值
		 */
		setOldParamValue: function (key, val) {
			var TransCode = "SH0002";
			var SerialNo = GetSerialNo();
			var SetValue = key + SECOND_SPLIT + val;
			var Asyn = ASYN_1;
			var sendmsg = TransCode + FIRST_SPLIT + SerialNo + FIRST_SPLIT + SetValue + FIRST_SPLIT + Asyn;
			var rec = top.window.external.tRANSTO2(sendmsg);
			var rcode = ParseMsg(rec, FIRST_SPLIT, 2);
			if (rcode == '0') {
				return '';
			}
			var recmsg = ParseMsg(rec, FIRST_SPLIT, 3);
			return rcode + "," + recmsg;
		},
		/**
		 * 内屏/外屏
		 * 删除键值对
		 * 旧版本方法，暂时保留，不建议使用
		 * @param {string} key 键
		 */
		delOldParamValue: function (key) {
			var TransCode = "SH0003";
			var SerialNo = GetSerialNo();
			var SetValue = key;
			var Asyn = ASYN_1;
			var sendmsg = TransCode + FIRST_SPLIT + SerialNo + FIRST_SPLIT + SetValue + FIRST_SPLIT + Asyn;
			top.window.external.tRANSTO2(sendmsg);
			return;
		},
		/**
		 * 内屏
		 * 获取外屏设备ID,待改为getParamValue('deviceid')(需要外屏发送过来)
		 */
		getDeviceNo: function () {
			var TransCode = "GT0001";
			var SerialNo = GetSerialNo();
			var SetValue = "";
			var Asyn = ASYN_1;
			var sendmsg = TransCode + FIRST_SPLIT + SerialNo + FIRST_SPLIT + SetValue + FIRST_SPLIT + Asyn;
			var rec = top.window.external.tRANSTO2(sendmsg);
			var rcode = ParseMsg(rec, FIRST_SPLIT, 2);
			if (rcode != '0') {
				return '';
			}
			var recmsg = ParseMsg(rec, FIRST_SPLIT, 3);
			recmsg = ParseMsg(recmsg, SECOND_SPLIT, 1);
			return recmsg;
		},
		/**
		 * 内屏
		 * 设置外屏设备ID,待改为sendKeyValue('deviceid', val)
		 * @param {string} val 设备ID
		 */
		setDeviceNo: function (val) {
			var TransCode = "GT0002";
			var SerialNo = GetSerialNo();
			var SetValue = val;
			var Asyn = ASYN_1;
			var sendmsg = TransCode + FIRST_SPLIT + SerialNo + FIRST_SPLIT + SetValue + FIRST_SPLIT + Asyn;
			var rec = top.window.external.tRANSTO2(sendmsg);
			var rcode = ParseMsg(rec, FIRST_SPLIT, 2);
			if (rcode == '0') {
				return '';
			}
			var recmsg = ParseMsg(rec, FIRST_SPLIT, 3);
			return rcode + "," + recmsg;
		},
		/**
		 * 内屏
		 * 获取外屏MAC和IP,待改为getParamValue('devicemac')和getParamValue('deviceip')(需要外屏发送过来)
		 */
		getMacIp: function () {
			var TransCode = "GT0003";
			var SerialNo = GetSerialNo();
			var SetValue = "";
			var Asyn = ASYN_1;
			var sendmsg = TransCode + FIRST_SPLIT + SerialNo + FIRST_SPLIT + SetValue + FIRST_SPLIT + Asyn;
			var rec = top.window.external.tRANSTO2(sendmsg);
			var rcode = ParseMsg(rec, FIRST_SPLIT, 2);
			if (rcode != '0') {
				return '';
			}
			var recmsg = ParseMsg(rec, FIRST_SPLIT, 3);
			return recmsg;
		},
		/**
		 * 内屏
		 * 设置客户端程序标题
		 * @param {string} title 标题
		 */
		setTitle: function (title) {
			try {
				top.window.external.setTitle(title);
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 内屏
		 * 拨打电话
		 * @param {string} callId 通话Id，唯一标识
		 * @param {string} custTel 客户电话号码
		 * @param {string} custType 客户类型
		 * @param {string} voiceName 录音文件名
		 */
		dialPhone: function (callId, custTel, custType, voiceName) {
			try {
				return window.external.dialPhone(callId, custTel, custType, voiceName)
			}
			catch (e) {
				return '-9999';
			}
		},
		/**
		 * 内屏
		 * 播放电话录音
		 * @param {string} file 录音文件名
		 */
		playTel: function (file) {
			try {
				return top.window.external.playTel(file);
			}
			catch (e) {
				return '-9999';
			}
		},
		/**
		 * 内屏
		 * 执行本地程序
		 * @param {string} file 本地程序相对/绝对路径，带参数
		 */
		runExe: function (file) {
			try {
				return top.window.external.runExe(file);
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 内屏
		 * 检测电话机跟PSTN线路连接状态
		 * 0 ：电话机跟PSTN线路断开
		 * 1 ：电话机跟PSTN线路连接
		 * 小于0 ：检测失败
		 */
		testPSTN: function () {
			try {
				return top.window.external.testPSTN();
			}
			catch (e) {
				return '-9999';
			}
		},
		/**
		 * 内屏
		 * 获取视频文件类型,avi/mp4
		 * @param {string} file 文件名不带后缀
		 */
		getVideoType: function (file) {
			try {
				return top.window.external.getVideoType(file);
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 内屏
		 * 检测网络是否连通
		 * 0：正常
		 * 其它：异常（网络不通）
		 * @param {string} ip ip地址或者主机名
		 */
		tryPing: function (ip) {
			try {
				return top.window.external.tryPing(ip);
			} catch (e) {
				return '-9999';
			}
		},
		/**
		 * 内屏
		 * 检测网络端口是否连通
		 * 0：正常
		 * 1：端口不通(服务未启动)
		 * 2：网络不通
		 * 其它：异常（网络不通）
		 * @param {string} ip ip地址或者主机名
		 * @param {string} port 端口号
		 */
		tryPort: function (ip, port) {
			try {
				return top.window.external.tryPort(ip, port);
			} catch (e) {
				return '-9999';
			}
		},
	};
})(jQuery);
 